import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { handleErrors, HTTP_CODE } from '../../utils/redirector-utils';

export const isReviewsCanonical = ({ data, path }) => {
  const { canonicalUrl } = data?.product?.identifiers || {};

  if (canonicalUrl) {
    const res = path?.split('/');
    let page = '';
    if (res?.length > 5) {
      page = '/' + res[5];
    } else {
      page = '/1';
    }

    const n = path?.lastIndexOf(page);
    const pathWithoutPage = path?.slice(0, n) + path?.slice(n).replace(page, '');
    const canonicalUrlWithContext = canonicalUrl?.replace('/p/', '/p/reviews/');

    if (pathWithoutPage !== canonicalUrlWithContext) {
      return {
        shouldRedirect: true,
        httpCode: HTTP_CODE.PERM_REDIRECT,
        redirectPath: canonicalUrlWithContext?.concat(page),
        description: 'redirected for canonical'
      };
    }
  }

  return null;
};
